import React from 'react'
import styled from 'styled-components'

import {
  inputBackground,
  inputBackgroundActive,
  borderColor,
} from 'styles/colors'
import { title } from 'styles/texts'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

const Input = styled.div`
  display: flex;
  padding: 11px 13px 12px;
  background-color: ${inputBackground};
  border: 1px solid ${borderColor};
  border-radius: ${props => (props.isOpen ? '4px 4px 0 0' : '4px')};
  cursor: pointer;
  outline: none;

  &:hover {
    background-color: ${inputBackgroundActive};
  }

  &:focus {
    background-color: ${inputBackgroundActive};
  }
`

const Value = styled.div`
  ${title};
  flex: 1;
`

const Menu = styled.div`
  position: absolute;
  z-index: 1;
  top: 100%;
  right: 0;
  left: 0;
  background-color: ${inputBackground};
  border: 1px solid ${borderColor};
  border-radius: 0 0 4px 4px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

const Item = styled.div`
  padding: 8px 13px;
  cursor: pointer;
  background-color: ${props =>
    props.isActive ? inputBackgroundActive : inputBackground};

  &:hover {
    background-color: ${inputBackgroundActive};
  }
`

class Select extends React.Component {
  state = {
    isOpen: false,
    activeIndex: undefined,
  }

  closeMenu = () => this.setState({ isOpen: false, activeIndex: undefined })

  render() {
    const { className, options, value, onChange } = this.props
    return (
      <Wrapper className={className}>
        <Input
          onClick={() => this.setState({ isOpen: true })}
          onBlur={this.closeMenu}
          onKeyDown={e => {
            if (this.state.isOpen) {
              if (e.key === ' ' || e.key === 'Escape') {
                e.preventDefault()
                this.closeMenu()
              } else if (e.key === 'ArrowDown') {
                e.preventDefault()
                this.setState(state => ({
                  activeIndex: (state.activeIndex + 1) % options.length,
                }))
              } else if (e.key === 'ArrowUp') {
                e.preventDefault()
                this.setState(state => ({
                  activeIndex:
                    (state.activeIndex + options.length - 1) % options.length,
                }))
              } else if (e.key === 'Enter') {
                e.preventDefault()
                onChange(options[this.state.activeIndex])
                this.closeMenu()
              }
            } else {
              if ([' ', 'Enter', 'ArrowDown', 'ArrowUp'].includes(e.key)) {
                e.preventDefault()
                this.setState({
                  isOpen: true,
                  activeIndex: 0,
                })
              }
            }
          }}
          tabIndex="0"
          isOpen={this.state.isOpen}>
          <Value>{options[value]}</Value>
          <img src="/icons/arrow_down_blue.svg" alt="" />
        </Input>
        {this.state.isOpen && (
          <Menu>
            {Object.keys(this.props.options).map((key, index) => (
              <Item
                isActive={this.state.activeIndex === index}
                key={key}
                onMouseDown={e => {
                  e.preventDefault()
                  onChange(key)
                  this.closeMenu()
                }}>
                {options[key]}
              </Item>
            ))}
          </Menu>
        )}
      </Wrapper>
    )
  }
}

export default Select



// WEBPACK FOOTER //
// ./src/components/form/Select.js